import React, { FC } from 'react';
import { DashboardBilling } from './DashboardBilling'; 
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';

function DashboardWrapper() {
  const intl = useIntl();
  
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'MENU.DASHBOARD' })} 
      </PageTitle>
      
      <div className='dashboard-wrapper-container'>
        <DashboardBilling />
      </div>
    </>
  );
}

export { DashboardWrapper };